import { numberWithSeparator } from '@diamond/shared/utils';

export interface FormatStockQtyOptions {
  fractionDigits?: number;
}

export const formatStockQty = (
  value: number,
  options?: FormatStockQtyOptions
) => {
  const fractionDigits = Math.min(options?.fractionDigits ?? 0, 3);
  if (Number.isInteger(value) || fractionDigits === 0) {
    return numberWithSeparator(String(value));
  }
  return numberWithSeparator(value.toFixed(fractionDigits));
};
